import React, { useState, useEffect } from "react";
import { Bookmark3 } from "../../../icons/Bookmarks3";
import { getLocalStorageData, sendAnalyticsToGA, setLocalStorageData } from "../../../utils/commanFunctions";
import HeartIcon from "../../../icons/HeartIcon";
import { trackFavorited } from "../../../utils/FunctionsForGa";

export const Bookmark = ({
  stateProp,
  className,
  icon = <HeartIcon className="!relative !w-4 !h-4" />,
  id,
  name,
  callFromParent=null,
  isBookmarked
}) => {
  const [isBookMarked, setIsBookMarked] = useState(() => {
    const bookMData = getLocalStorageData("tripBookmarked",{ids:[]}) || { ids: [] };
    return bookMData.ids.includes(id);
  });

  const handleBookMark = (op = "add", id) => {
    let bookMData = getLocalStorageData("tripBookmarked",{ids:[]}) || { ids: [] };

    let idsSet = new Set(bookMData.ids);

    if (op === "add") {
      idsSet.add(id);
      setIsBookMarked(true);
    } else {
      idsSet.delete(id);
      setIsBookMarked(false);
    }

    bookMData.ids = [...idsSet];
    setLocalStorageData("tripBookmarked",JSON.stringify(bookMData),true);
  };

  useEffect(() => {    
    if (callFromParent !== null) {
      handleBookMark(isBookMarked ? "remove" : "add",id);
    }
  }, [callFromParent]);

  return (
    <div
      className={`inline-flex items-center gap-1 px-2 py-1.5 overflow-hidden relative bookmark-css ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        const action = isBookmarked() ? "removed" : "added"
                  trackFavorited({
                    action: action,
                    store_id: id,
                    name: name
                  });
        handleBookMark(isBookMarked ? "remove" : "add", id);
      }}
    >
      {React.cloneElement(icon, { isBookMarked })}
    </div>
  );
};
